import tagModel from "../../../../models/custom-vision/custom-vision.tags.model";
import { Dialog } from 'construct-ui';
import paginationComponent from '../../../../components/pagination/pagination.component';
import ViewBase from '../../../view-base.view';
import CVTagAddView from '../cvtags/custom-vision.tags-add.view';
import CVTagEditView from '../cvtags/custom-vision.tags-edit.view';

export default function CVTagsListView() {
    ViewBase.call(this);

    let inputDataModel = { searchTagOrDescription: "", totalCount: 0, pageIndex: 1, pageSize: 10 };

    let listOfTags = [];

    let selectedProjectId = 0;
    let selectedTagId = 0;
    let isPopupAddTagOpened = false;
    let isPopupEditTagOpened = false;

    let _loadTags = () => {
        this.showLoading();

        tagModel.getTagsList(            
            (result) => {
                this.hideLoading();

                listOfTags = result.data;
                if (listOfTags == null) {
                    listOfTags = [];
                }

                inputDataModel.totalCount = result.total;
                inputDataModel.pageIndex = result.pageIndex;
                inputDataModel.pageSize = result.pageSize;
            },
            (error) => {
                listOfTags = [];

                this.hideLoading();
                this.handleError(error);
            },
            selectedProjectId,
            inputDataModel.searchTagOrDescription, inputDataModel.pageIndex, inputDataModel.pageSize
        );
    }

    let _getSearchTagOrDescription = (e) => {
        inputDataModel.searchTagOrDescription = e.target.value;
    }

    let _search = () => {
        inputDataModel.pageIndex = 1;
        _loadTags();
    }

    let _clearFilter = () => {
        inputDataModel.searchTagOrDescription = "";
        _loadTags();
    }

    let _onPageSizeChanged = (pageIndex, pageSize) => {
        inputDataModel.pageIndex = pageIndex;
        inputDataModel.pageSize = pageSize;
        _loadTags();
    }

    let _onPageChanged = (pageIndex) => {
        inputDataModel.pageIndex = pageIndex;
        _loadTags();
    }

    let _onAddTagComplete = () => {
        isPopupAddTagOpened = false;
        _loadTags();
    }

    let _onEditTagComplete = () => {
        isPopupEditTagOpened = false;
        _loadTags();
    }

    let _createNewTag = () => {
        isPopupAddTagOpened = true;
    }

    let _showEditTagPopup = (tagId) => {
        isPopupEditTagOpened = true;
        selectedTagId = tagId;
    }

    let _showDeleteTagConfirmation = (tagId) => {
        this.showConfirm(this.getText("LT00000140", "Are you sure you want to delete this tag?"), this.getText("LT00000141", "Delete Tag"), (e) => {

            if (e == "YES") {
                tagModel.deactivateTag(
                    () => {
                        this.showMessage(this.getText("LT00000142", "The tag has been deleted."), this.getText("LT00000141", "Delete Tag"));

                        _loadTags();
                    }, (error) => {
                        this.handleError(error);
                    },
                    selectedProjectId,
                    tagId);
            }
        });

    }

    return {
        oninit: (vnode) => {
            if (vnode.attrs.projectId) {
                selectedProjectId = vnode.attrs.projectId;

                _loadTags();
            }
        },
        view: (vnode) => {
            return [
                m('.row',
                    m('.col-md-12',
                        m('.d-flex.justify-content-end.mb-2',
                            m('a.btn.btn-outline-primary.btn-search[data-bs-toggle="collapse"][href="#showSearchBarRc"][role="button"][aria-controls="showSearchBar"][aria-expanded="false"]',
                                m('span.search-arrow.me-2',
                                    m('i.bi.bi-search')
                                ), this.getText("LT00000001", "Search")
                            )
                        ),
                        m('.card mb-3.searchbox.collapse[id="showSearchBarRc"]',
                            m('.card-body.py-3',
                                m('.row',
                                    m('.container',
                                        m('.row',
                                            m('.col-md-6',
                                                m('label.form-label', this.getText("LT00000377", "Tag Name / Description")),
                                                m('input[type=text][placeholder=' + this.getText("LT00000377", "Tag Name / Description") + '][value="' + inputDataModel.searchTagOrDescription + '"].form-control.form-control-bg', { onchange: _getSearchTagOrDescription }
                                                )
                                            ),
                                            m('.col-md-6.gap-2.d-sm-flex.mt-4',
                                                m('button.btn.btn-primary.px-4.gap-3', { onclick: _search }, this.getText("LT00000001", "Search")),
                                                m('button.btn.btn-white.px-4.gap-3', { onclick: _clearFilter }, this.getText("LT00000031", "Clear")),
                                            ),
                                        )
                                    )
                                )
                            )
                        ),
                        m('.card',
                            m('.card-body',
                                m('.d-flex.justify-content-end mb-2',
                                    m('button.btn.btn-outline-primary[type="button"]',  
                                        { onclick: _createNewTag }, [
                                            m("i.bi.bi-plus-lg.me-0")
                                        ]                                                            
                                    )
                                ),
                                m(".table-responsive",
                                    m("table.table table-striped",
                                        [
                                            m("thead",
                                                m("tr.align-middle",
                                                    [
                                                        m("th", { "scope": "col" }, this.getText("LT00000134", "Tag")),
                                                        m("th", { "scope": "col" }, this.getText("LT00000012", "Description")),
                                                        m("th", { "scope": "col", "colspan": "2" }, "")
                                                    ])
                                            ),
                                            m("tbody",
                                                listOfTags.length == 0 &&
                                                m("tr", { "class": "align-middle" },
                                                    m("td", { "colspan": "4" }, this.getText("EM00000141", "No records found."))
                                                ),
                                                listOfTags.map(tag =>
                                                    [
                                                        m("tr",
                                                            [
                                                                m("td", tag.name),
                                                                m("td", tag.description),
                                                                m("td", m("a", { "href": "javascript:;", onclick: () => { _showEditTagPopup(tag.id) } }, m("span", this.getText("LT00000128", "Edit")))),
                                                                m("td", m("a", { "href": "javascript:;", onclick: () => { _showDeleteTagConfirmation(tag.id) } }, m("span", this.getText("LT00000135", "Delete"))))
                                                            ])
                                                    ]),
                                            )
                                        ]
                                    )
                                ),
                                m(paginationComponent,
                                    {
                                        currentPage: inputDataModel.pageIndex,
                                        pageSize: inputDataModel.pageSize,
                                        totalItems: inputDataModel.totalCount,
                                        onPageChanged: _onPageChanged,
                                        onPageSizeChanged: _onPageSizeChanged
                                    }
                                )
                            )
                        )
                    ),
                    m(Dialog, {
                        isOpen: isPopupAddTagOpened,
                        transitionDuration: 200,
                        closeOnOutsideClick: false,
                        onClose: () => { isPopupAddTagOpened = false; },
                        title: this.getText("LT00000058", "Create"),
                        content: m(CVTagAddView, {
                            onPopupClose: () => { isPopupAddTagOpened = false },
                            onSaveComplete: _onAddTagComplete,
                            projectId: selectedProjectId,
                            listOfTags: listOfTags,
                        }),
                        "class": "cui-dialog-xxl"
                    }),
                    m(Dialog, {
                        isOpen: isPopupEditTagOpened,
                        transitionDuration: 200,
                        closeOnOutsideClick: false,
                        onClose: () => { isPopupEditTagOpened = false; },
                        title: this.getText("LT00000128", "Edit"),
                        content: m(CVTagEditView, {
                            onPopupClose: () => { isPopupEditTagOpened = false },
                            onSaveComplete: _onEditTagComplete,
                            projectId: selectedProjectId,
                            tagId: selectedTagId,
                            listOfTags: listOfTags,
                        }),
                        "class": "cui-dialog-xxl"
                    }),
                ),
                this.getBaseViews()
            ]
        }
    }
}
